/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthCallbackRouteImport } from "./routes/auth.callback";
import { Route as AuthenticatedVehiclesRouteImport } from "./routes/_authenticated/vehicles";
import { Route as AuthenticatedVehicleTypesRouteImport } from "./routes/_authenticated/vehicle-types";
import { Route as AuthenticatedVehicleHandoversRouteImport } from "./routes/_authenticated/vehicle-handovers";
import { Route as AuthenticatedTasksRouteImport } from "./routes/_authenticated/tasks";
import { Route as AuthenticatedSteeringRouteImport } from "./routes/_authenticated/steering";
import { Route as AuthenticatedSitesRouteImport } from "./routes/_authenticated/sites";
import { Route as AuthenticatedShowcaseRouteImport } from "./routes/_authenticated/showcase";
import { Route as AuthenticatedServicePartnersRouteImport } from "./routes/_authenticated/service-partners";
import { Route as AuthenticatedReportingRouteImport } from "./routes/_authenticated/reporting";
import { Route as AuthenticatedPlatformManagementRouteImport } from "./routes/_authenticated/platform-management";
import { Route as AuthenticatedOrdersRouteImport } from "./routes/_authenticated/orders";
import { Route as AuthenticatedNieuwsRouteImport } from "./routes/_authenticated/nieuws";
import { Route as AuthenticatedMobilityCategoriesRouteImport } from "./routes/_authenticated/mobility-categories";
import { Route as AuthenticatedInboxRouteImport } from "./routes/_authenticated/inbox";
import { Route as AuthenticatedEmployeesRouteImport } from "./routes/_authenticated/employees";
import { Route as AuthenticatedDossiersRouteImport } from "./routes/_authenticated/dossiers";
import { Route as AuthenticatedDashboardRouteImport } from "./routes/_authenticated/dashboard";
import { Route as AuthenticatedContractPlanningRouteImport } from "./routes/_authenticated/contract-planning";
import { Route as AuthenticatedContractMonitorRouteImport } from "./routes/_authenticated/contract-monitor";
import { Route as AuthenticatedContractExpirationsRouteImport } from "./routes/_authenticated/contract-expirations";
import { Route as AuthenticatedContractDistanceRouteImport } from "./routes/_authenticated/contract-distance";
import { Route as AuthenticatedCompaniesRouteImport } from "./routes/_authenticated/companies";
import { Route as AuthenticatedChargingContractsRouteImport } from "./routes/_authenticated/charging-contracts";
import { Route as AuthenticatedAffiliateManagementRouteImport } from "./routes/_authenticated/affiliate-management";
import { Route as AuthenticatedAccountRouteImport } from "./routes/_authenticated/account";
import { Route as AuthenticatedVehiclesVehicleIdRouteImport } from "./routes/_authenticated/vehicles_.$vehicleId";
import { Route as AuthenticatedVehicleHandoversVehicleHandoverIdRouteImport } from "./routes/_authenticated/vehicle-handovers_.$vehicleHandoverId";
import { Route as AuthenticatedSteeringQueryIdRouteImport } from "./routes/_authenticated/steering_.$queryId";
import { Route as AuthenticatedServicePartnersServicePartnerIdRouteImport } from "./routes/_authenticated/service-partners_.$servicePartnerId";
import { Route as AuthenticatedPlatformManagementServicePartnersRouteImport } from "./routes/_authenticated/platform-management_.service-partners";
import { Route as AuthenticatedPlatformManagementCompaniesRouteImport } from "./routes/_authenticated/platform-management_.companies";
import { Route as AuthenticatedPlatformManagementAffiliatesRouteImport } from "./routes/_authenticated/platform-management_.affiliates";
import { Route as AuthenticatedOrdersOrderIdRouteImport } from "./routes/_authenticated/orders_.$orderId";
import { Route as AuthenticatedEmployeesEmployeeIdRouteImport } from "./routes/_authenticated/employees_.$employeeId";
import { Route as AuthenticatedDossiersNewRouteImport } from "./routes/_authenticated/dossiers_.new";
import { Route as AuthenticatedDossiersDossierIdRouteImport } from "./routes/_authenticated/dossiers_.$dossierId";
import { Route as AuthenticatedContractExpirationsContractExpirationIdRouteImport } from "./routes/_authenticated/contract-expirations_.$contractExpirationId";
import { Route as AuthenticatedConfiguratorVehicleTypesRouteImport } from "./routes/_authenticated/configurator/vehicle-types";
import { Route as AuthenticatedConfiguratorVehicleConversionsRouteImport } from "./routes/_authenticated/configurator/vehicle-conversions";
import { Route as AuthenticatedConfiguratorVehicleCategoriesRouteImport } from "./routes/_authenticated/configurator/vehicle-categories";
import { Route as AuthenticatedConfiguratorRequestsRouteImport } from "./routes/_authenticated/configurator/requests";
import { Route as AuthenticatedConfiguratorInvitesRouteImport } from "./routes/_authenticated/configurator/invites";
import { Route as AuthenticatedCompaniesCompanyIdRouteImport } from "./routes/_authenticated/companies_.$companyId";
import { Route as AuthenticatedChargingContractsContractIdRouteImport } from "./routes/_authenticated/charging-contracts_.$contractId";
import { Route as AuthenticatedAffiliateManagementTeamsRouteImport } from "./routes/_authenticated/affiliate-management_.teams";
import { Route as AuthenticatedSteeringQueryIdNewRouteImport } from "./routes/_authenticated/steering_.$queryId_.new";
import { Route as AuthenticatedPlatformManagementServicePartnersNewRouteImport } from "./routes/_authenticated/platform-management_.service-partners_.new";
import { Route as AuthenticatedPlatformManagementServicePartnersServicePartnerIdRouteImport } from "./routes/_authenticated/platform-management_.service-partners_.$servicePartnerId";
import { Route as AuthenticatedPlatformManagementCompaniesNewRouteImport } from "./routes/_authenticated/platform-management_.companies_.new";
import { Route as AuthenticatedPlatformManagementCompaniesCompanyIdRouteImport } from "./routes/_authenticated/platform-management_.companies_.$companyId";
import { Route as AuthenticatedPlatformManagementAffiliatesNewRouteImport } from "./routes/_authenticated/platform-management_.affiliates_.new";
import { Route as AuthenticatedPlatformManagementAffiliatesAffiliateIdRouteImport } from "./routes/_authenticated/platform-management_.affiliates_.$affiliateId";
import { Route as AuthenticatedDossiersExportsExportIdRouteImport } from "./routes/_authenticated/dossiers_.exports_.$exportId";
import { Route as AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRouteImport } from "./routes/_authenticated/configurator/vehicle-types_.$vehicleTypeId";
import { Route as AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRouteImport } from "./routes/_authenticated/configurator/vehicle-conversions_.$vehicleConversionId";
import { Route as AuthenticatedConfiguratorRequestsNewRouteImport } from "./routes/_authenticated/configurator/requests_.new";
import { Route as AuthenticatedConfiguratorRequestsConfiguratorRequestIdRouteImport } from "./routes/_authenticated/configurator/requests_.$configuratorRequestId";
import { Route as AuthenticatedConfiguratorInvitesConfiguratorInviteIdRouteImport } from "./routes/_authenticated/configurator/invites_.$configuratorInviteId";
import { Route as AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRouteImport } from "./routes/_authenticated/configurator/vehicle-types_.$vehicleTypeId_.edit";
import { Route as AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRouteImport } from "./routes/_authenticated/configurator/vehicle-conversions_.$vehicleConversionId_.edit";
import { Route as AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRouteImport } from "./routes/_authenticated/steering_.$queryId_.revisions.$revisionId.edit";

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedVehiclesRoute = AuthenticatedVehiclesRouteImport.update({
  id: "/vehicles",
  path: "/vehicles",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedVehicleTypesRoute =
  AuthenticatedVehicleTypesRouteImport.update({
    id: "/vehicle-types",
    path: "/vehicle-types",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedVehicleHandoversRoute =
  AuthenticatedVehicleHandoversRouteImport.update({
    id: "/vehicle-handovers",
    path: "/vehicle-handovers",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTasksRoute = AuthenticatedTasksRouteImport.update({
  id: "/tasks",
  path: "/tasks",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSteeringRoute = AuthenticatedSteeringRouteImport.update({
  id: "/steering",
  path: "/steering",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSitesRoute = AuthenticatedSitesRouteImport.update({
  id: "/sites",
  path: "/sites",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedShowcaseRoute = AuthenticatedShowcaseRouteImport.update({
  id: "/showcase",
  path: "/showcase",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedServicePartnersRoute =
  AuthenticatedServicePartnersRouteImport.update({
    id: "/service-partners",
    path: "/service-partners",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedReportingRoute = AuthenticatedReportingRouteImport.update({
  id: "/reporting",
  path: "/reporting",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedPlatformManagementRoute =
  AuthenticatedPlatformManagementRouteImport.update({
    id: "/platform-management",
    path: "/platform-management",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedOrdersRoute = AuthenticatedOrdersRouteImport.update({
  id: "/orders",
  path: "/orders",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedNieuwsRoute = AuthenticatedNieuwsRouteImport.update({
  id: "/nieuws",
  path: "/nieuws",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedMobilityCategoriesRoute =
  AuthenticatedMobilityCategoriesRouteImport.update({
    id: "/mobility-categories",
    path: "/mobility-categories",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInboxRoute = AuthenticatedInboxRouteImport.update({
  id: "/inbox",
  path: "/inbox",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedEmployeesRoute = AuthenticatedEmployeesRouteImport.update({
  id: "/employees",
  path: "/employees",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedDossiersRoute = AuthenticatedDossiersRouteImport.update({
  id: "/dossiers",
  path: "/dossiers",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedContractPlanningRoute =
  AuthenticatedContractPlanningRouteImport.update({
    id: "/contract-planning",
    path: "/contract-planning",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedContractMonitorRoute =
  AuthenticatedContractMonitorRouteImport.update({
    id: "/contract-monitor",
    path: "/contract-monitor",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedContractExpirationsRoute =
  AuthenticatedContractExpirationsRouteImport.update({
    id: "/contract-expirations",
    path: "/contract-expirations",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedContractDistanceRoute =
  AuthenticatedContractDistanceRouteImport.update({
    id: "/contract-distance",
    path: "/contract-distance",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedCompaniesRoute = AuthenticatedCompaniesRouteImport.update({
  id: "/companies",
  path: "/companies",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedChargingContractsRoute =
  AuthenticatedChargingContractsRouteImport.update({
    id: "/charging-contracts",
    path: "/charging-contracts",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAffiliateManagementRoute =
  AuthenticatedAffiliateManagementRouteImport.update({
    id: "/affiliate-management",
    path: "/affiliate-management",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedVehiclesVehicleIdRoute =
  AuthenticatedVehiclesVehicleIdRouteImport.update({
    id: "/vehicles_/$vehicleId",
    path: "/vehicles/$vehicleId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedVehicleHandoversVehicleHandoverIdRoute =
  AuthenticatedVehicleHandoversVehicleHandoverIdRouteImport.update({
    id: "/vehicle-handovers_/$vehicleHandoverId",
    path: "/vehicle-handovers/$vehicleHandoverId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSteeringQueryIdRoute =
  AuthenticatedSteeringQueryIdRouteImport.update({
    id: "/steering_/$queryId",
    path: "/steering/$queryId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedServicePartnersServicePartnerIdRoute =
  AuthenticatedServicePartnersServicePartnerIdRouteImport.update({
    id: "/service-partners_/$servicePartnerId",
    path: "/service-partners/$servicePartnerId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlatformManagementServicePartnersRoute =
  AuthenticatedPlatformManagementServicePartnersRouteImport.update({
    id: "/platform-management_/service-partners",
    path: "/platform-management/service-partners",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlatformManagementCompaniesRoute =
  AuthenticatedPlatformManagementCompaniesRouteImport.update({
    id: "/platform-management_/companies",
    path: "/platform-management/companies",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlatformManagementAffiliatesRoute =
  AuthenticatedPlatformManagementAffiliatesRouteImport.update({
    id: "/platform-management_/affiliates",
    path: "/platform-management/affiliates",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedOrdersOrderIdRoute =
  AuthenticatedOrdersOrderIdRouteImport.update({
    id: "/orders_/$orderId",
    path: "/orders/$orderId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedEmployeesEmployeeIdRoute =
  AuthenticatedEmployeesEmployeeIdRouteImport.update({
    id: "/employees_/$employeeId",
    path: "/employees/$employeeId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedDossiersNewRoute =
  AuthenticatedDossiersNewRouteImport.update({
    id: "/dossiers_/new",
    path: "/dossiers/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedDossiersDossierIdRoute =
  AuthenticatedDossiersDossierIdRouteImport.update({
    id: "/dossiers_/$dossierId",
    path: "/dossiers/$dossierId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedContractExpirationsContractExpirationIdRoute =
  AuthenticatedContractExpirationsContractExpirationIdRouteImport.update({
    id: "/contract-expirations_/$contractExpirationId",
    path: "/contract-expirations/$contractExpirationId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorVehicleTypesRoute =
  AuthenticatedConfiguratorVehicleTypesRouteImport.update({
    id: "/configurator/vehicle-types",
    path: "/configurator/vehicle-types",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorVehicleConversionsRoute =
  AuthenticatedConfiguratorVehicleConversionsRouteImport.update({
    id: "/configurator/vehicle-conversions",
    path: "/configurator/vehicle-conversions",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorVehicleCategoriesRoute =
  AuthenticatedConfiguratorVehicleCategoriesRouteImport.update({
    id: "/configurator/vehicle-categories",
    path: "/configurator/vehicle-categories",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorRequestsRoute =
  AuthenticatedConfiguratorRequestsRouteImport.update({
    id: "/configurator/requests",
    path: "/configurator/requests",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorInvitesRoute =
  AuthenticatedConfiguratorInvitesRouteImport.update({
    id: "/configurator/invites",
    path: "/configurator/invites",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedCompaniesCompanyIdRoute =
  AuthenticatedCompaniesCompanyIdRouteImport.update({
    id: "/companies_/$companyId",
    path: "/companies/$companyId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedChargingContractsContractIdRoute =
  AuthenticatedChargingContractsContractIdRouteImport.update({
    id: "/charging-contracts_/$contractId",
    path: "/charging-contracts/$contractId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAffiliateManagementTeamsRoute =
  AuthenticatedAffiliateManagementTeamsRouteImport.update({
    id: "/affiliate-management_/teams",
    path: "/affiliate-management/teams",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSteeringQueryIdNewRoute =
  AuthenticatedSteeringQueryIdNewRouteImport.update({
    id: "/steering_/$queryId_/new",
    path: "/steering/$queryId/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlatformManagementServicePartnersNewRoute =
  AuthenticatedPlatformManagementServicePartnersNewRouteImport.update({
    id: "/platform-management_/service-partners_/new",
    path: "/platform-management/service-partners/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlatformManagementServicePartnersServicePartnerIdRoute =
  AuthenticatedPlatformManagementServicePartnersServicePartnerIdRouteImport.update(
    {
      id: "/platform-management_/service-partners_/$servicePartnerId",
      path: "/platform-management/service-partners/$servicePartnerId",
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  );
const AuthenticatedPlatformManagementCompaniesNewRoute =
  AuthenticatedPlatformManagementCompaniesNewRouteImport.update({
    id: "/platform-management_/companies_/new",
    path: "/platform-management/companies/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlatformManagementCompaniesCompanyIdRoute =
  AuthenticatedPlatformManagementCompaniesCompanyIdRouteImport.update({
    id: "/platform-management_/companies_/$companyId",
    path: "/platform-management/companies/$companyId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlatformManagementAffiliatesNewRoute =
  AuthenticatedPlatformManagementAffiliatesNewRouteImport.update({
    id: "/platform-management_/affiliates_/new",
    path: "/platform-management/affiliates/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlatformManagementAffiliatesAffiliateIdRoute =
  AuthenticatedPlatformManagementAffiliatesAffiliateIdRouteImport.update({
    id: "/platform-management_/affiliates_/$affiliateId",
    path: "/platform-management/affiliates/$affiliateId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedDossiersExportsExportIdRoute =
  AuthenticatedDossiersExportsExportIdRouteImport.update({
    id: "/dossiers_/exports_/$exportId",
    path: "/dossiers/exports/$exportId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRoute =
  AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRouteImport.update({
    id: "/configurator/vehicle-types_/$vehicleTypeId",
    path: "/configurator/vehicle-types/$vehicleTypeId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRoute =
  AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRouteImport.update(
    {
      id: "/configurator/vehicle-conversions_/$vehicleConversionId",
      path: "/configurator/vehicle-conversions/$vehicleConversionId",
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  );
const AuthenticatedConfiguratorRequestsNewRoute =
  AuthenticatedConfiguratorRequestsNewRouteImport.update({
    id: "/configurator/requests_/new",
    path: "/configurator/requests/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorRequestsConfiguratorRequestIdRoute =
  AuthenticatedConfiguratorRequestsConfiguratorRequestIdRouteImport.update({
    id: "/configurator/requests_/$configuratorRequestId",
    path: "/configurator/requests/$configuratorRequestId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorInvitesConfiguratorInviteIdRoute =
  AuthenticatedConfiguratorInvitesConfiguratorInviteIdRouteImport.update({
    id: "/configurator/invites_/$configuratorInviteId",
    path: "/configurator/invites/$configuratorInviteId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRoute =
  AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRouteImport.update({
    id: "/configurator/vehicle-types_/$vehicleTypeId_/edit",
    path: "/configurator/vehicle-types/$vehicleTypeId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRoute =
  AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRouteImport.update(
    {
      id: "/configurator/vehicle-conversions_/$vehicleConversionId_/edit",
      path: "/configurator/vehicle-conversions/$vehicleConversionId/edit",
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  );
const AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRoute =
  AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRouteImport.update({
    id: "/steering_/$queryId_/revisions/$revisionId/edit",
    path: "/steering/$queryId/revisions/$revisionId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/account": typeof AuthenticatedAccountRoute;
  "/affiliate-management": typeof AuthenticatedAffiliateManagementRoute;
  "/charging-contracts": typeof AuthenticatedChargingContractsRoute;
  "/companies": typeof AuthenticatedCompaniesRoute;
  "/contract-distance": typeof AuthenticatedContractDistanceRoute;
  "/contract-expirations": typeof AuthenticatedContractExpirationsRoute;
  "/contract-monitor": typeof AuthenticatedContractMonitorRoute;
  "/contract-planning": typeof AuthenticatedContractPlanningRoute;
  "/dashboard": typeof AuthenticatedDashboardRoute;
  "/dossiers": typeof AuthenticatedDossiersRoute;
  "/employees": typeof AuthenticatedEmployeesRoute;
  "/inbox": typeof AuthenticatedInboxRoute;
  "/mobility-categories": typeof AuthenticatedMobilityCategoriesRoute;
  "/nieuws": typeof AuthenticatedNieuwsRoute;
  "/orders": typeof AuthenticatedOrdersRoute;
  "/platform-management": typeof AuthenticatedPlatformManagementRoute;
  "/reporting": typeof AuthenticatedReportingRoute;
  "/service-partners": typeof AuthenticatedServicePartnersRoute;
  "/showcase": typeof AuthenticatedShowcaseRoute;
  "/sites": typeof AuthenticatedSitesRoute;
  "/steering": typeof AuthenticatedSteeringRoute;
  "/tasks": typeof AuthenticatedTasksRoute;
  "/vehicle-handovers": typeof AuthenticatedVehicleHandoversRoute;
  "/vehicle-types": typeof AuthenticatedVehicleTypesRoute;
  "/vehicles": typeof AuthenticatedVehiclesRoute;
  "/auth/callback": typeof AuthCallbackRoute;
  "/affiliate-management/teams": typeof AuthenticatedAffiliateManagementTeamsRoute;
  "/charging-contracts/$contractId": typeof AuthenticatedChargingContractsContractIdRoute;
  "/companies/$companyId": typeof AuthenticatedCompaniesCompanyIdRoute;
  "/configurator/invites": typeof AuthenticatedConfiguratorInvitesRoute;
  "/configurator/requests": typeof AuthenticatedConfiguratorRequestsRoute;
  "/configurator/vehicle-categories": typeof AuthenticatedConfiguratorVehicleCategoriesRoute;
  "/configurator/vehicle-conversions": typeof AuthenticatedConfiguratorVehicleConversionsRoute;
  "/configurator/vehicle-types": typeof AuthenticatedConfiguratorVehicleTypesRoute;
  "/contract-expirations/$contractExpirationId": typeof AuthenticatedContractExpirationsContractExpirationIdRoute;
  "/dossiers/$dossierId": typeof AuthenticatedDossiersDossierIdRoute;
  "/dossiers/new": typeof AuthenticatedDossiersNewRoute;
  "/employees/$employeeId": typeof AuthenticatedEmployeesEmployeeIdRoute;
  "/orders/$orderId": typeof AuthenticatedOrdersOrderIdRoute;
  "/platform-management/affiliates": typeof AuthenticatedPlatformManagementAffiliatesRoute;
  "/platform-management/companies": typeof AuthenticatedPlatformManagementCompaniesRoute;
  "/platform-management/service-partners": typeof AuthenticatedPlatformManagementServicePartnersRoute;
  "/service-partners/$servicePartnerId": typeof AuthenticatedServicePartnersServicePartnerIdRoute;
  "/steering/$queryId": typeof AuthenticatedSteeringQueryIdRoute;
  "/vehicle-handovers/$vehicleHandoverId": typeof AuthenticatedVehicleHandoversVehicleHandoverIdRoute;
  "/vehicles/$vehicleId": typeof AuthenticatedVehiclesVehicleIdRoute;
  "/configurator/invites/$configuratorInviteId": typeof AuthenticatedConfiguratorInvitesConfiguratorInviteIdRoute;
  "/configurator/requests/$configuratorRequestId": typeof AuthenticatedConfiguratorRequestsConfiguratorRequestIdRoute;
  "/configurator/requests/new": typeof AuthenticatedConfiguratorRequestsNewRoute;
  "/configurator/vehicle-conversions/$vehicleConversionId": typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRoute;
  "/configurator/vehicle-types/$vehicleTypeId": typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRoute;
  "/dossiers/exports/$exportId": typeof AuthenticatedDossiersExportsExportIdRoute;
  "/platform-management/affiliates/$affiliateId": typeof AuthenticatedPlatformManagementAffiliatesAffiliateIdRoute;
  "/platform-management/affiliates/new": typeof AuthenticatedPlatformManagementAffiliatesNewRoute;
  "/platform-management/companies/$companyId": typeof AuthenticatedPlatformManagementCompaniesCompanyIdRoute;
  "/platform-management/companies/new": typeof AuthenticatedPlatformManagementCompaniesNewRoute;
  "/platform-management/service-partners/$servicePartnerId": typeof AuthenticatedPlatformManagementServicePartnersServicePartnerIdRoute;
  "/platform-management/service-partners/new": typeof AuthenticatedPlatformManagementServicePartnersNewRoute;
  "/steering/$queryId/new": typeof AuthenticatedSteeringQueryIdNewRoute;
  "/configurator/vehicle-conversions/$vehicleConversionId/edit": typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRoute;
  "/configurator/vehicle-types/$vehicleTypeId/edit": typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRoute;
  "/steering/$queryId/revisions/$revisionId/edit": typeof AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/account": typeof AuthenticatedAccountRoute;
  "/affiliate-management": typeof AuthenticatedAffiliateManagementRoute;
  "/charging-contracts": typeof AuthenticatedChargingContractsRoute;
  "/companies": typeof AuthenticatedCompaniesRoute;
  "/contract-distance": typeof AuthenticatedContractDistanceRoute;
  "/contract-expirations": typeof AuthenticatedContractExpirationsRoute;
  "/contract-monitor": typeof AuthenticatedContractMonitorRoute;
  "/contract-planning": typeof AuthenticatedContractPlanningRoute;
  "/dashboard": typeof AuthenticatedDashboardRoute;
  "/dossiers": typeof AuthenticatedDossiersRoute;
  "/employees": typeof AuthenticatedEmployeesRoute;
  "/inbox": typeof AuthenticatedInboxRoute;
  "/mobility-categories": typeof AuthenticatedMobilityCategoriesRoute;
  "/nieuws": typeof AuthenticatedNieuwsRoute;
  "/orders": typeof AuthenticatedOrdersRoute;
  "/platform-management": typeof AuthenticatedPlatformManagementRoute;
  "/reporting": typeof AuthenticatedReportingRoute;
  "/service-partners": typeof AuthenticatedServicePartnersRoute;
  "/showcase": typeof AuthenticatedShowcaseRoute;
  "/sites": typeof AuthenticatedSitesRoute;
  "/steering": typeof AuthenticatedSteeringRoute;
  "/tasks": typeof AuthenticatedTasksRoute;
  "/vehicle-handovers": typeof AuthenticatedVehicleHandoversRoute;
  "/vehicle-types": typeof AuthenticatedVehicleTypesRoute;
  "/vehicles": typeof AuthenticatedVehiclesRoute;
  "/auth/callback": typeof AuthCallbackRoute;
  "/affiliate-management/teams": typeof AuthenticatedAffiliateManagementTeamsRoute;
  "/charging-contracts/$contractId": typeof AuthenticatedChargingContractsContractIdRoute;
  "/companies/$companyId": typeof AuthenticatedCompaniesCompanyIdRoute;
  "/configurator/invites": typeof AuthenticatedConfiguratorInvitesRoute;
  "/configurator/requests": typeof AuthenticatedConfiguratorRequestsRoute;
  "/configurator/vehicle-categories": typeof AuthenticatedConfiguratorVehicleCategoriesRoute;
  "/configurator/vehicle-conversions": typeof AuthenticatedConfiguratorVehicleConversionsRoute;
  "/configurator/vehicle-types": typeof AuthenticatedConfiguratorVehicleTypesRoute;
  "/contract-expirations/$contractExpirationId": typeof AuthenticatedContractExpirationsContractExpirationIdRoute;
  "/dossiers/$dossierId": typeof AuthenticatedDossiersDossierIdRoute;
  "/dossiers/new": typeof AuthenticatedDossiersNewRoute;
  "/employees/$employeeId": typeof AuthenticatedEmployeesEmployeeIdRoute;
  "/orders/$orderId": typeof AuthenticatedOrdersOrderIdRoute;
  "/platform-management/affiliates": typeof AuthenticatedPlatformManagementAffiliatesRoute;
  "/platform-management/companies": typeof AuthenticatedPlatformManagementCompaniesRoute;
  "/platform-management/service-partners": typeof AuthenticatedPlatformManagementServicePartnersRoute;
  "/service-partners/$servicePartnerId": typeof AuthenticatedServicePartnersServicePartnerIdRoute;
  "/steering/$queryId": typeof AuthenticatedSteeringQueryIdRoute;
  "/vehicle-handovers/$vehicleHandoverId": typeof AuthenticatedVehicleHandoversVehicleHandoverIdRoute;
  "/vehicles/$vehicleId": typeof AuthenticatedVehiclesVehicleIdRoute;
  "/configurator/invites/$configuratorInviteId": typeof AuthenticatedConfiguratorInvitesConfiguratorInviteIdRoute;
  "/configurator/requests/$configuratorRequestId": typeof AuthenticatedConfiguratorRequestsConfiguratorRequestIdRoute;
  "/configurator/requests/new": typeof AuthenticatedConfiguratorRequestsNewRoute;
  "/configurator/vehicle-conversions/$vehicleConversionId": typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRoute;
  "/configurator/vehicle-types/$vehicleTypeId": typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRoute;
  "/dossiers/exports/$exportId": typeof AuthenticatedDossiersExportsExportIdRoute;
  "/platform-management/affiliates/$affiliateId": typeof AuthenticatedPlatformManagementAffiliatesAffiliateIdRoute;
  "/platform-management/affiliates/new": typeof AuthenticatedPlatformManagementAffiliatesNewRoute;
  "/platform-management/companies/$companyId": typeof AuthenticatedPlatformManagementCompaniesCompanyIdRoute;
  "/platform-management/companies/new": typeof AuthenticatedPlatformManagementCompaniesNewRoute;
  "/platform-management/service-partners/$servicePartnerId": typeof AuthenticatedPlatformManagementServicePartnersServicePartnerIdRoute;
  "/platform-management/service-partners/new": typeof AuthenticatedPlatformManagementServicePartnersNewRoute;
  "/steering/$queryId/new": typeof AuthenticatedSteeringQueryIdNewRoute;
  "/configurator/vehicle-conversions/$vehicleConversionId/edit": typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRoute;
  "/configurator/vehicle-types/$vehicleTypeId/edit": typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRoute;
  "/steering/$queryId/revisions/$revisionId/edit": typeof AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/_authenticated/account": typeof AuthenticatedAccountRoute;
  "/_authenticated/affiliate-management": typeof AuthenticatedAffiliateManagementRoute;
  "/_authenticated/charging-contracts": typeof AuthenticatedChargingContractsRoute;
  "/_authenticated/companies": typeof AuthenticatedCompaniesRoute;
  "/_authenticated/contract-distance": typeof AuthenticatedContractDistanceRoute;
  "/_authenticated/contract-expirations": typeof AuthenticatedContractExpirationsRoute;
  "/_authenticated/contract-monitor": typeof AuthenticatedContractMonitorRoute;
  "/_authenticated/contract-planning": typeof AuthenticatedContractPlanningRoute;
  "/_authenticated/dashboard": typeof AuthenticatedDashboardRoute;
  "/_authenticated/dossiers": typeof AuthenticatedDossiersRoute;
  "/_authenticated/employees": typeof AuthenticatedEmployeesRoute;
  "/_authenticated/inbox": typeof AuthenticatedInboxRoute;
  "/_authenticated/mobility-categories": typeof AuthenticatedMobilityCategoriesRoute;
  "/_authenticated/nieuws": typeof AuthenticatedNieuwsRoute;
  "/_authenticated/orders": typeof AuthenticatedOrdersRoute;
  "/_authenticated/platform-management": typeof AuthenticatedPlatformManagementRoute;
  "/_authenticated/reporting": typeof AuthenticatedReportingRoute;
  "/_authenticated/service-partners": typeof AuthenticatedServicePartnersRoute;
  "/_authenticated/showcase": typeof AuthenticatedShowcaseRoute;
  "/_authenticated/sites": typeof AuthenticatedSitesRoute;
  "/_authenticated/steering": typeof AuthenticatedSteeringRoute;
  "/_authenticated/tasks": typeof AuthenticatedTasksRoute;
  "/_authenticated/vehicle-handovers": typeof AuthenticatedVehicleHandoversRoute;
  "/_authenticated/vehicle-types": typeof AuthenticatedVehicleTypesRoute;
  "/_authenticated/vehicles": typeof AuthenticatedVehiclesRoute;
  "/auth/callback": typeof AuthCallbackRoute;
  "/_authenticated/affiliate-management_/teams": typeof AuthenticatedAffiliateManagementTeamsRoute;
  "/_authenticated/charging-contracts_/$contractId": typeof AuthenticatedChargingContractsContractIdRoute;
  "/_authenticated/companies_/$companyId": typeof AuthenticatedCompaniesCompanyIdRoute;
  "/_authenticated/configurator/invites": typeof AuthenticatedConfiguratorInvitesRoute;
  "/_authenticated/configurator/requests": typeof AuthenticatedConfiguratorRequestsRoute;
  "/_authenticated/configurator/vehicle-categories": typeof AuthenticatedConfiguratorVehicleCategoriesRoute;
  "/_authenticated/configurator/vehicle-conversions": typeof AuthenticatedConfiguratorVehicleConversionsRoute;
  "/_authenticated/configurator/vehicle-types": typeof AuthenticatedConfiguratorVehicleTypesRoute;
  "/_authenticated/contract-expirations_/$contractExpirationId": typeof AuthenticatedContractExpirationsContractExpirationIdRoute;
  "/_authenticated/dossiers_/$dossierId": typeof AuthenticatedDossiersDossierIdRoute;
  "/_authenticated/dossiers_/new": typeof AuthenticatedDossiersNewRoute;
  "/_authenticated/employees_/$employeeId": typeof AuthenticatedEmployeesEmployeeIdRoute;
  "/_authenticated/orders_/$orderId": typeof AuthenticatedOrdersOrderIdRoute;
  "/_authenticated/platform-management_/affiliates": typeof AuthenticatedPlatformManagementAffiliatesRoute;
  "/_authenticated/platform-management_/companies": typeof AuthenticatedPlatformManagementCompaniesRoute;
  "/_authenticated/platform-management_/service-partners": typeof AuthenticatedPlatformManagementServicePartnersRoute;
  "/_authenticated/service-partners_/$servicePartnerId": typeof AuthenticatedServicePartnersServicePartnerIdRoute;
  "/_authenticated/steering_/$queryId": typeof AuthenticatedSteeringQueryIdRoute;
  "/_authenticated/vehicle-handovers_/$vehicleHandoverId": typeof AuthenticatedVehicleHandoversVehicleHandoverIdRoute;
  "/_authenticated/vehicles_/$vehicleId": typeof AuthenticatedVehiclesVehicleIdRoute;
  "/_authenticated/configurator/invites_/$configuratorInviteId": typeof AuthenticatedConfiguratorInvitesConfiguratorInviteIdRoute;
  "/_authenticated/configurator/requests_/$configuratorRequestId": typeof AuthenticatedConfiguratorRequestsConfiguratorRequestIdRoute;
  "/_authenticated/configurator/requests_/new": typeof AuthenticatedConfiguratorRequestsNewRoute;
  "/_authenticated/configurator/vehicle-conversions_/$vehicleConversionId": typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRoute;
  "/_authenticated/configurator/vehicle-types_/$vehicleTypeId": typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRoute;
  "/_authenticated/dossiers_/exports_/$exportId": typeof AuthenticatedDossiersExportsExportIdRoute;
  "/_authenticated/platform-management_/affiliates_/$affiliateId": typeof AuthenticatedPlatformManagementAffiliatesAffiliateIdRoute;
  "/_authenticated/platform-management_/affiliates_/new": typeof AuthenticatedPlatformManagementAffiliatesNewRoute;
  "/_authenticated/platform-management_/companies_/$companyId": typeof AuthenticatedPlatformManagementCompaniesCompanyIdRoute;
  "/_authenticated/platform-management_/companies_/new": typeof AuthenticatedPlatformManagementCompaniesNewRoute;
  "/_authenticated/platform-management_/service-partners_/$servicePartnerId": typeof AuthenticatedPlatformManagementServicePartnersServicePartnerIdRoute;
  "/_authenticated/platform-management_/service-partners_/new": typeof AuthenticatedPlatformManagementServicePartnersNewRoute;
  "/_authenticated/steering_/$queryId_/new": typeof AuthenticatedSteeringQueryIdNewRoute;
  "/_authenticated/configurator/vehicle-conversions_/$vehicleConversionId_/edit": typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRoute;
  "/_authenticated/configurator/vehicle-types_/$vehicleTypeId_/edit": typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRoute;
  "/_authenticated/steering_/$queryId_/revisions/$revisionId/edit": typeof AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/account"
    | "/affiliate-management"
    | "/charging-contracts"
    | "/companies"
    | "/contract-distance"
    | "/contract-expirations"
    | "/contract-monitor"
    | "/contract-planning"
    | "/dashboard"
    | "/dossiers"
    | "/employees"
    | "/inbox"
    | "/mobility-categories"
    | "/nieuws"
    | "/orders"
    | "/platform-management"
    | "/reporting"
    | "/service-partners"
    | "/showcase"
    | "/sites"
    | "/steering"
    | "/tasks"
    | "/vehicle-handovers"
    | "/vehicle-types"
    | "/vehicles"
    | "/auth/callback"
    | "/affiliate-management/teams"
    | "/charging-contracts/$contractId"
    | "/companies/$companyId"
    | "/configurator/invites"
    | "/configurator/requests"
    | "/configurator/vehicle-categories"
    | "/configurator/vehicle-conversions"
    | "/configurator/vehicle-types"
    | "/contract-expirations/$contractExpirationId"
    | "/dossiers/$dossierId"
    | "/dossiers/new"
    | "/employees/$employeeId"
    | "/orders/$orderId"
    | "/platform-management/affiliates"
    | "/platform-management/companies"
    | "/platform-management/service-partners"
    | "/service-partners/$servicePartnerId"
    | "/steering/$queryId"
    | "/vehicle-handovers/$vehicleHandoverId"
    | "/vehicles/$vehicleId"
    | "/configurator/invites/$configuratorInviteId"
    | "/configurator/requests/$configuratorRequestId"
    | "/configurator/requests/new"
    | "/configurator/vehicle-conversions/$vehicleConversionId"
    | "/configurator/vehicle-types/$vehicleTypeId"
    | "/dossiers/exports/$exportId"
    | "/platform-management/affiliates/$affiliateId"
    | "/platform-management/affiliates/new"
    | "/platform-management/companies/$companyId"
    | "/platform-management/companies/new"
    | "/platform-management/service-partners/$servicePartnerId"
    | "/platform-management/service-partners/new"
    | "/steering/$queryId/new"
    | "/configurator/vehicle-conversions/$vehicleConversionId/edit"
    | "/configurator/vehicle-types/$vehicleTypeId/edit"
    | "/steering/$queryId/revisions/$revisionId/edit";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/account"
    | "/affiliate-management"
    | "/charging-contracts"
    | "/companies"
    | "/contract-distance"
    | "/contract-expirations"
    | "/contract-monitor"
    | "/contract-planning"
    | "/dashboard"
    | "/dossiers"
    | "/employees"
    | "/inbox"
    | "/mobility-categories"
    | "/nieuws"
    | "/orders"
    | "/platform-management"
    | "/reporting"
    | "/service-partners"
    | "/showcase"
    | "/sites"
    | "/steering"
    | "/tasks"
    | "/vehicle-handovers"
    | "/vehicle-types"
    | "/vehicles"
    | "/auth/callback"
    | "/affiliate-management/teams"
    | "/charging-contracts/$contractId"
    | "/companies/$companyId"
    | "/configurator/invites"
    | "/configurator/requests"
    | "/configurator/vehicle-categories"
    | "/configurator/vehicle-conversions"
    | "/configurator/vehicle-types"
    | "/contract-expirations/$contractExpirationId"
    | "/dossiers/$dossierId"
    | "/dossiers/new"
    | "/employees/$employeeId"
    | "/orders/$orderId"
    | "/platform-management/affiliates"
    | "/platform-management/companies"
    | "/platform-management/service-partners"
    | "/service-partners/$servicePartnerId"
    | "/steering/$queryId"
    | "/vehicle-handovers/$vehicleHandoverId"
    | "/vehicles/$vehicleId"
    | "/configurator/invites/$configuratorInviteId"
    | "/configurator/requests/$configuratorRequestId"
    | "/configurator/requests/new"
    | "/configurator/vehicle-conversions/$vehicleConversionId"
    | "/configurator/vehicle-types/$vehicleTypeId"
    | "/dossiers/exports/$exportId"
    | "/platform-management/affiliates/$affiliateId"
    | "/platform-management/affiliates/new"
    | "/platform-management/companies/$companyId"
    | "/platform-management/companies/new"
    | "/platform-management/service-partners/$servicePartnerId"
    | "/platform-management/service-partners/new"
    | "/steering/$queryId/new"
    | "/configurator/vehicle-conversions/$vehicleConversionId/edit"
    | "/configurator/vehicle-types/$vehicleTypeId/edit"
    | "/steering/$queryId/revisions/$revisionId/edit";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/_authenticated/account"
    | "/_authenticated/affiliate-management"
    | "/_authenticated/charging-contracts"
    | "/_authenticated/companies"
    | "/_authenticated/contract-distance"
    | "/_authenticated/contract-expirations"
    | "/_authenticated/contract-monitor"
    | "/_authenticated/contract-planning"
    | "/_authenticated/dashboard"
    | "/_authenticated/dossiers"
    | "/_authenticated/employees"
    | "/_authenticated/inbox"
    | "/_authenticated/mobility-categories"
    | "/_authenticated/nieuws"
    | "/_authenticated/orders"
    | "/_authenticated/platform-management"
    | "/_authenticated/reporting"
    | "/_authenticated/service-partners"
    | "/_authenticated/showcase"
    | "/_authenticated/sites"
    | "/_authenticated/steering"
    | "/_authenticated/tasks"
    | "/_authenticated/vehicle-handovers"
    | "/_authenticated/vehicle-types"
    | "/_authenticated/vehicles"
    | "/auth/callback"
    | "/_authenticated/affiliate-management_/teams"
    | "/_authenticated/charging-contracts_/$contractId"
    | "/_authenticated/companies_/$companyId"
    | "/_authenticated/configurator/invites"
    | "/_authenticated/configurator/requests"
    | "/_authenticated/configurator/vehicle-categories"
    | "/_authenticated/configurator/vehicle-conversions"
    | "/_authenticated/configurator/vehicle-types"
    | "/_authenticated/contract-expirations_/$contractExpirationId"
    | "/_authenticated/dossiers_/$dossierId"
    | "/_authenticated/dossiers_/new"
    | "/_authenticated/employees_/$employeeId"
    | "/_authenticated/orders_/$orderId"
    | "/_authenticated/platform-management_/affiliates"
    | "/_authenticated/platform-management_/companies"
    | "/_authenticated/platform-management_/service-partners"
    | "/_authenticated/service-partners_/$servicePartnerId"
    | "/_authenticated/steering_/$queryId"
    | "/_authenticated/vehicle-handovers_/$vehicleHandoverId"
    | "/_authenticated/vehicles_/$vehicleId"
    | "/_authenticated/configurator/invites_/$configuratorInviteId"
    | "/_authenticated/configurator/requests_/$configuratorRequestId"
    | "/_authenticated/configurator/requests_/new"
    | "/_authenticated/configurator/vehicle-conversions_/$vehicleConversionId"
    | "/_authenticated/configurator/vehicle-types_/$vehicleTypeId"
    | "/_authenticated/dossiers_/exports_/$exportId"
    | "/_authenticated/platform-management_/affiliates_/$affiliateId"
    | "/_authenticated/platform-management_/affiliates_/new"
    | "/_authenticated/platform-management_/companies_/$companyId"
    | "/_authenticated/platform-management_/companies_/new"
    | "/_authenticated/platform-management_/service-partners_/$servicePartnerId"
    | "/_authenticated/platform-management_/service-partners_/new"
    | "/_authenticated/steering_/$queryId_/new"
    | "/_authenticated/configurator/vehicle-conversions_/$vehicleConversionId_/edit"
    | "/_authenticated/configurator/vehicle-types_/$vehicleTypeId_/edit"
    | "/_authenticated/steering_/$queryId_/revisions/$revisionId/edit";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  AuthCallbackRoute: typeof AuthCallbackRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/callback": {
      id: "/auth/callback";
      path: "/auth/callback";
      fullPath: "/auth/callback";
      preLoaderRoute: typeof AuthCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/vehicles": {
      id: "/_authenticated/vehicles";
      path: "/vehicles";
      fullPath: "/vehicles";
      preLoaderRoute: typeof AuthenticatedVehiclesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/vehicle-types": {
      id: "/_authenticated/vehicle-types";
      path: "/vehicle-types";
      fullPath: "/vehicle-types";
      preLoaderRoute: typeof AuthenticatedVehicleTypesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/vehicle-handovers": {
      id: "/_authenticated/vehicle-handovers";
      path: "/vehicle-handovers";
      fullPath: "/vehicle-handovers";
      preLoaderRoute: typeof AuthenticatedVehicleHandoversRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/tasks": {
      id: "/_authenticated/tasks";
      path: "/tasks";
      fullPath: "/tasks";
      preLoaderRoute: typeof AuthenticatedTasksRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/steering": {
      id: "/_authenticated/steering";
      path: "/steering";
      fullPath: "/steering";
      preLoaderRoute: typeof AuthenticatedSteeringRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/sites": {
      id: "/_authenticated/sites";
      path: "/sites";
      fullPath: "/sites";
      preLoaderRoute: typeof AuthenticatedSitesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/showcase": {
      id: "/_authenticated/showcase";
      path: "/showcase";
      fullPath: "/showcase";
      preLoaderRoute: typeof AuthenticatedShowcaseRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/service-partners": {
      id: "/_authenticated/service-partners";
      path: "/service-partners";
      fullPath: "/service-partners";
      preLoaderRoute: typeof AuthenticatedServicePartnersRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/reporting": {
      id: "/_authenticated/reporting";
      path: "/reporting";
      fullPath: "/reporting";
      preLoaderRoute: typeof AuthenticatedReportingRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management": {
      id: "/_authenticated/platform-management";
      path: "/platform-management";
      fullPath: "/platform-management";
      preLoaderRoute: typeof AuthenticatedPlatformManagementRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/orders": {
      id: "/_authenticated/orders";
      path: "/orders";
      fullPath: "/orders";
      preLoaderRoute: typeof AuthenticatedOrdersRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/nieuws": {
      id: "/_authenticated/nieuws";
      path: "/nieuws";
      fullPath: "/nieuws";
      preLoaderRoute: typeof AuthenticatedNieuwsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/mobility-categories": {
      id: "/_authenticated/mobility-categories";
      path: "/mobility-categories";
      fullPath: "/mobility-categories";
      preLoaderRoute: typeof AuthenticatedMobilityCategoriesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/inbox": {
      id: "/_authenticated/inbox";
      path: "/inbox";
      fullPath: "/inbox";
      preLoaderRoute: typeof AuthenticatedInboxRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/employees": {
      id: "/_authenticated/employees";
      path: "/employees";
      fullPath: "/employees";
      preLoaderRoute: typeof AuthenticatedEmployeesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/dossiers": {
      id: "/_authenticated/dossiers";
      path: "/dossiers";
      fullPath: "/dossiers";
      preLoaderRoute: typeof AuthenticatedDossiersRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/dashboard": {
      id: "/_authenticated/dashboard";
      path: "/dashboard";
      fullPath: "/dashboard";
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/contract-planning": {
      id: "/_authenticated/contract-planning";
      path: "/contract-planning";
      fullPath: "/contract-planning";
      preLoaderRoute: typeof AuthenticatedContractPlanningRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/contract-monitor": {
      id: "/_authenticated/contract-monitor";
      path: "/contract-monitor";
      fullPath: "/contract-monitor";
      preLoaderRoute: typeof AuthenticatedContractMonitorRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/contract-expirations": {
      id: "/_authenticated/contract-expirations";
      path: "/contract-expirations";
      fullPath: "/contract-expirations";
      preLoaderRoute: typeof AuthenticatedContractExpirationsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/contract-distance": {
      id: "/_authenticated/contract-distance";
      path: "/contract-distance";
      fullPath: "/contract-distance";
      preLoaderRoute: typeof AuthenticatedContractDistanceRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/companies": {
      id: "/_authenticated/companies";
      path: "/companies";
      fullPath: "/companies";
      preLoaderRoute: typeof AuthenticatedCompaniesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/charging-contracts": {
      id: "/_authenticated/charging-contracts";
      path: "/charging-contracts";
      fullPath: "/charging-contracts";
      preLoaderRoute: typeof AuthenticatedChargingContractsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/affiliate-management": {
      id: "/_authenticated/affiliate-management";
      path: "/affiliate-management";
      fullPath: "/affiliate-management";
      preLoaderRoute: typeof AuthenticatedAffiliateManagementRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/account": {
      id: "/_authenticated/account";
      path: "/account";
      fullPath: "/account";
      preLoaderRoute: typeof AuthenticatedAccountRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/vehicles_/$vehicleId": {
      id: "/_authenticated/vehicles_/$vehicleId";
      path: "/vehicles/$vehicleId";
      fullPath: "/vehicles/$vehicleId";
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/vehicle-handovers_/$vehicleHandoverId": {
      id: "/_authenticated/vehicle-handovers_/$vehicleHandoverId";
      path: "/vehicle-handovers/$vehicleHandoverId";
      fullPath: "/vehicle-handovers/$vehicleHandoverId";
      preLoaderRoute: typeof AuthenticatedVehicleHandoversVehicleHandoverIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/steering_/$queryId": {
      id: "/_authenticated/steering_/$queryId";
      path: "/steering/$queryId";
      fullPath: "/steering/$queryId";
      preLoaderRoute: typeof AuthenticatedSteeringQueryIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/service-partners_/$servicePartnerId": {
      id: "/_authenticated/service-partners_/$servicePartnerId";
      path: "/service-partners/$servicePartnerId";
      fullPath: "/service-partners/$servicePartnerId";
      preLoaderRoute: typeof AuthenticatedServicePartnersServicePartnerIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management_/service-partners": {
      id: "/_authenticated/platform-management_/service-partners";
      path: "/platform-management/service-partners";
      fullPath: "/platform-management/service-partners";
      preLoaderRoute: typeof AuthenticatedPlatformManagementServicePartnersRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management_/companies": {
      id: "/_authenticated/platform-management_/companies";
      path: "/platform-management/companies";
      fullPath: "/platform-management/companies";
      preLoaderRoute: typeof AuthenticatedPlatformManagementCompaniesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management_/affiliates": {
      id: "/_authenticated/platform-management_/affiliates";
      path: "/platform-management/affiliates";
      fullPath: "/platform-management/affiliates";
      preLoaderRoute: typeof AuthenticatedPlatformManagementAffiliatesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/orders_/$orderId": {
      id: "/_authenticated/orders_/$orderId";
      path: "/orders/$orderId";
      fullPath: "/orders/$orderId";
      preLoaderRoute: typeof AuthenticatedOrdersOrderIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/employees_/$employeeId": {
      id: "/_authenticated/employees_/$employeeId";
      path: "/employees/$employeeId";
      fullPath: "/employees/$employeeId";
      preLoaderRoute: typeof AuthenticatedEmployeesEmployeeIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/dossiers_/new": {
      id: "/_authenticated/dossiers_/new";
      path: "/dossiers/new";
      fullPath: "/dossiers/new";
      preLoaderRoute: typeof AuthenticatedDossiersNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/dossiers_/$dossierId": {
      id: "/_authenticated/dossiers_/$dossierId";
      path: "/dossiers/$dossierId";
      fullPath: "/dossiers/$dossierId";
      preLoaderRoute: typeof AuthenticatedDossiersDossierIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/contract-expirations_/$contractExpirationId": {
      id: "/_authenticated/contract-expirations_/$contractExpirationId";
      path: "/contract-expirations/$contractExpirationId";
      fullPath: "/contract-expirations/$contractExpirationId";
      preLoaderRoute: typeof AuthenticatedContractExpirationsContractExpirationIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/vehicle-types": {
      id: "/_authenticated/configurator/vehicle-types";
      path: "/configurator/vehicle-types";
      fullPath: "/configurator/vehicle-types";
      preLoaderRoute: typeof AuthenticatedConfiguratorVehicleTypesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/vehicle-conversions": {
      id: "/_authenticated/configurator/vehicle-conversions";
      path: "/configurator/vehicle-conversions";
      fullPath: "/configurator/vehicle-conversions";
      preLoaderRoute: typeof AuthenticatedConfiguratorVehicleConversionsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/vehicle-categories": {
      id: "/_authenticated/configurator/vehicle-categories";
      path: "/configurator/vehicle-categories";
      fullPath: "/configurator/vehicle-categories";
      preLoaderRoute: typeof AuthenticatedConfiguratorVehicleCategoriesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/requests": {
      id: "/_authenticated/configurator/requests";
      path: "/configurator/requests";
      fullPath: "/configurator/requests";
      preLoaderRoute: typeof AuthenticatedConfiguratorRequestsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/invites": {
      id: "/_authenticated/configurator/invites";
      path: "/configurator/invites";
      fullPath: "/configurator/invites";
      preLoaderRoute: typeof AuthenticatedConfiguratorInvitesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/companies_/$companyId": {
      id: "/_authenticated/companies_/$companyId";
      path: "/companies/$companyId";
      fullPath: "/companies/$companyId";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/charging-contracts_/$contractId": {
      id: "/_authenticated/charging-contracts_/$contractId";
      path: "/charging-contracts/$contractId";
      fullPath: "/charging-contracts/$contractId";
      preLoaderRoute: typeof AuthenticatedChargingContractsContractIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/affiliate-management_/teams": {
      id: "/_authenticated/affiliate-management_/teams";
      path: "/affiliate-management/teams";
      fullPath: "/affiliate-management/teams";
      preLoaderRoute: typeof AuthenticatedAffiliateManagementTeamsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/steering_/$queryId_/new": {
      id: "/_authenticated/steering_/$queryId_/new";
      path: "/steering/$queryId/new";
      fullPath: "/steering/$queryId/new";
      preLoaderRoute: typeof AuthenticatedSteeringQueryIdNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management_/service-partners_/new": {
      id: "/_authenticated/platform-management_/service-partners_/new";
      path: "/platform-management/service-partners/new";
      fullPath: "/platform-management/service-partners/new";
      preLoaderRoute: typeof AuthenticatedPlatformManagementServicePartnersNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management_/service-partners_/$servicePartnerId": {
      id: "/_authenticated/platform-management_/service-partners_/$servicePartnerId";
      path: "/platform-management/service-partners/$servicePartnerId";
      fullPath: "/platform-management/service-partners/$servicePartnerId";
      preLoaderRoute: typeof AuthenticatedPlatformManagementServicePartnersServicePartnerIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management_/companies_/new": {
      id: "/_authenticated/platform-management_/companies_/new";
      path: "/platform-management/companies/new";
      fullPath: "/platform-management/companies/new";
      preLoaderRoute: typeof AuthenticatedPlatformManagementCompaniesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management_/companies_/$companyId": {
      id: "/_authenticated/platform-management_/companies_/$companyId";
      path: "/platform-management/companies/$companyId";
      fullPath: "/platform-management/companies/$companyId";
      preLoaderRoute: typeof AuthenticatedPlatformManagementCompaniesCompanyIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management_/affiliates_/new": {
      id: "/_authenticated/platform-management_/affiliates_/new";
      path: "/platform-management/affiliates/new";
      fullPath: "/platform-management/affiliates/new";
      preLoaderRoute: typeof AuthenticatedPlatformManagementAffiliatesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/platform-management_/affiliates_/$affiliateId": {
      id: "/_authenticated/platform-management_/affiliates_/$affiliateId";
      path: "/platform-management/affiliates/$affiliateId";
      fullPath: "/platform-management/affiliates/$affiliateId";
      preLoaderRoute: typeof AuthenticatedPlatformManagementAffiliatesAffiliateIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/dossiers_/exports_/$exportId": {
      id: "/_authenticated/dossiers_/exports_/$exportId";
      path: "/dossiers/exports/$exportId";
      fullPath: "/dossiers/exports/$exportId";
      preLoaderRoute: typeof AuthenticatedDossiersExportsExportIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/vehicle-types_/$vehicleTypeId": {
      id: "/_authenticated/configurator/vehicle-types_/$vehicleTypeId";
      path: "/configurator/vehicle-types/$vehicleTypeId";
      fullPath: "/configurator/vehicle-types/$vehicleTypeId";
      preLoaderRoute: typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/vehicle-conversions_/$vehicleConversionId": {
      id: "/_authenticated/configurator/vehicle-conversions_/$vehicleConversionId";
      path: "/configurator/vehicle-conversions/$vehicleConversionId";
      fullPath: "/configurator/vehicle-conversions/$vehicleConversionId";
      preLoaderRoute: typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/requests_/new": {
      id: "/_authenticated/configurator/requests_/new";
      path: "/configurator/requests/new";
      fullPath: "/configurator/requests/new";
      preLoaderRoute: typeof AuthenticatedConfiguratorRequestsNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/requests_/$configuratorRequestId": {
      id: "/_authenticated/configurator/requests_/$configuratorRequestId";
      path: "/configurator/requests/$configuratorRequestId";
      fullPath: "/configurator/requests/$configuratorRequestId";
      preLoaderRoute: typeof AuthenticatedConfiguratorRequestsConfiguratorRequestIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/invites_/$configuratorInviteId": {
      id: "/_authenticated/configurator/invites_/$configuratorInviteId";
      path: "/configurator/invites/$configuratorInviteId";
      fullPath: "/configurator/invites/$configuratorInviteId";
      preLoaderRoute: typeof AuthenticatedConfiguratorInvitesConfiguratorInviteIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/vehicle-types_/$vehicleTypeId_/edit": {
      id: "/_authenticated/configurator/vehicle-types_/$vehicleTypeId_/edit";
      path: "/configurator/vehicle-types/$vehicleTypeId/edit";
      fullPath: "/configurator/vehicle-types/$vehicleTypeId/edit";
      preLoaderRoute: typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/configurator/vehicle-conversions_/$vehicleConversionId_/edit": {
      id: "/_authenticated/configurator/vehicle-conversions_/$vehicleConversionId_/edit";
      path: "/configurator/vehicle-conversions/$vehicleConversionId/edit";
      fullPath: "/configurator/vehicle-conversions/$vehicleConversionId/edit";
      preLoaderRoute: typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/steering_/$queryId_/revisions/$revisionId/edit": {
      id: "/_authenticated/steering_/$queryId_/revisions/$revisionId/edit";
      path: "/steering/$queryId/revisions/$revisionId/edit";
      fullPath: "/steering/$queryId/revisions/$revisionId/edit";
      preLoaderRoute: typeof AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute;
  AuthenticatedAffiliateManagementRoute: typeof AuthenticatedAffiliateManagementRoute;
  AuthenticatedChargingContractsRoute: typeof AuthenticatedChargingContractsRoute;
  AuthenticatedCompaniesRoute: typeof AuthenticatedCompaniesRoute;
  AuthenticatedContractDistanceRoute: typeof AuthenticatedContractDistanceRoute;
  AuthenticatedContractExpirationsRoute: typeof AuthenticatedContractExpirationsRoute;
  AuthenticatedContractMonitorRoute: typeof AuthenticatedContractMonitorRoute;
  AuthenticatedContractPlanningRoute: typeof AuthenticatedContractPlanningRoute;
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute;
  AuthenticatedDossiersRoute: typeof AuthenticatedDossiersRoute;
  AuthenticatedEmployeesRoute: typeof AuthenticatedEmployeesRoute;
  AuthenticatedInboxRoute: typeof AuthenticatedInboxRoute;
  AuthenticatedMobilityCategoriesRoute: typeof AuthenticatedMobilityCategoriesRoute;
  AuthenticatedNieuwsRoute: typeof AuthenticatedNieuwsRoute;
  AuthenticatedOrdersRoute: typeof AuthenticatedOrdersRoute;
  AuthenticatedPlatformManagementRoute: typeof AuthenticatedPlatformManagementRoute;
  AuthenticatedReportingRoute: typeof AuthenticatedReportingRoute;
  AuthenticatedServicePartnersRoute: typeof AuthenticatedServicePartnersRoute;
  AuthenticatedShowcaseRoute: typeof AuthenticatedShowcaseRoute;
  AuthenticatedSitesRoute: typeof AuthenticatedSitesRoute;
  AuthenticatedSteeringRoute: typeof AuthenticatedSteeringRoute;
  AuthenticatedTasksRoute: typeof AuthenticatedTasksRoute;
  AuthenticatedVehicleHandoversRoute: typeof AuthenticatedVehicleHandoversRoute;
  AuthenticatedVehicleTypesRoute: typeof AuthenticatedVehicleTypesRoute;
  AuthenticatedVehiclesRoute: typeof AuthenticatedVehiclesRoute;
  AuthenticatedAffiliateManagementTeamsRoute: typeof AuthenticatedAffiliateManagementTeamsRoute;
  AuthenticatedChargingContractsContractIdRoute: typeof AuthenticatedChargingContractsContractIdRoute;
  AuthenticatedCompaniesCompanyIdRoute: typeof AuthenticatedCompaniesCompanyIdRoute;
  AuthenticatedConfiguratorInvitesRoute: typeof AuthenticatedConfiguratorInvitesRoute;
  AuthenticatedConfiguratorRequestsRoute: typeof AuthenticatedConfiguratorRequestsRoute;
  AuthenticatedConfiguratorVehicleCategoriesRoute: typeof AuthenticatedConfiguratorVehicleCategoriesRoute;
  AuthenticatedConfiguratorVehicleConversionsRoute: typeof AuthenticatedConfiguratorVehicleConversionsRoute;
  AuthenticatedConfiguratorVehicleTypesRoute: typeof AuthenticatedConfiguratorVehicleTypesRoute;
  AuthenticatedContractExpirationsContractExpirationIdRoute: typeof AuthenticatedContractExpirationsContractExpirationIdRoute;
  AuthenticatedDossiersDossierIdRoute: typeof AuthenticatedDossiersDossierIdRoute;
  AuthenticatedDossiersNewRoute: typeof AuthenticatedDossiersNewRoute;
  AuthenticatedEmployeesEmployeeIdRoute: typeof AuthenticatedEmployeesEmployeeIdRoute;
  AuthenticatedOrdersOrderIdRoute: typeof AuthenticatedOrdersOrderIdRoute;
  AuthenticatedPlatformManagementAffiliatesRoute: typeof AuthenticatedPlatformManagementAffiliatesRoute;
  AuthenticatedPlatformManagementCompaniesRoute: typeof AuthenticatedPlatformManagementCompaniesRoute;
  AuthenticatedPlatformManagementServicePartnersRoute: typeof AuthenticatedPlatformManagementServicePartnersRoute;
  AuthenticatedServicePartnersServicePartnerIdRoute: typeof AuthenticatedServicePartnersServicePartnerIdRoute;
  AuthenticatedSteeringQueryIdRoute: typeof AuthenticatedSteeringQueryIdRoute;
  AuthenticatedVehicleHandoversVehicleHandoverIdRoute: typeof AuthenticatedVehicleHandoversVehicleHandoverIdRoute;
  AuthenticatedVehiclesVehicleIdRoute: typeof AuthenticatedVehiclesVehicleIdRoute;
  AuthenticatedConfiguratorInvitesConfiguratorInviteIdRoute: typeof AuthenticatedConfiguratorInvitesConfiguratorInviteIdRoute;
  AuthenticatedConfiguratorRequestsConfiguratorRequestIdRoute: typeof AuthenticatedConfiguratorRequestsConfiguratorRequestIdRoute;
  AuthenticatedConfiguratorRequestsNewRoute: typeof AuthenticatedConfiguratorRequestsNewRoute;
  AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRoute: typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRoute;
  AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRoute: typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRoute;
  AuthenticatedDossiersExportsExportIdRoute: typeof AuthenticatedDossiersExportsExportIdRoute;
  AuthenticatedPlatformManagementAffiliatesAffiliateIdRoute: typeof AuthenticatedPlatformManagementAffiliatesAffiliateIdRoute;
  AuthenticatedPlatformManagementAffiliatesNewRoute: typeof AuthenticatedPlatformManagementAffiliatesNewRoute;
  AuthenticatedPlatformManagementCompaniesCompanyIdRoute: typeof AuthenticatedPlatformManagementCompaniesCompanyIdRoute;
  AuthenticatedPlatformManagementCompaniesNewRoute: typeof AuthenticatedPlatformManagementCompaniesNewRoute;
  AuthenticatedPlatformManagementServicePartnersServicePartnerIdRoute: typeof AuthenticatedPlatformManagementServicePartnersServicePartnerIdRoute;
  AuthenticatedPlatformManagementServicePartnersNewRoute: typeof AuthenticatedPlatformManagementServicePartnersNewRoute;
  AuthenticatedSteeringQueryIdNewRoute: typeof AuthenticatedSteeringQueryIdNewRoute;
  AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRoute: typeof AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRoute;
  AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRoute: typeof AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRoute;
  AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRoute: typeof AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedAffiliateManagementRoute: AuthenticatedAffiliateManagementRoute,
  AuthenticatedChargingContractsRoute: AuthenticatedChargingContractsRoute,
  AuthenticatedCompaniesRoute: AuthenticatedCompaniesRoute,
  AuthenticatedContractDistanceRoute: AuthenticatedContractDistanceRoute,
  AuthenticatedContractExpirationsRoute: AuthenticatedContractExpirationsRoute,
  AuthenticatedContractMonitorRoute: AuthenticatedContractMonitorRoute,
  AuthenticatedContractPlanningRoute: AuthenticatedContractPlanningRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDossiersRoute: AuthenticatedDossiersRoute,
  AuthenticatedEmployeesRoute: AuthenticatedEmployeesRoute,
  AuthenticatedInboxRoute: AuthenticatedInboxRoute,
  AuthenticatedMobilityCategoriesRoute: AuthenticatedMobilityCategoriesRoute,
  AuthenticatedNieuwsRoute: AuthenticatedNieuwsRoute,
  AuthenticatedOrdersRoute: AuthenticatedOrdersRoute,
  AuthenticatedPlatformManagementRoute: AuthenticatedPlatformManagementRoute,
  AuthenticatedReportingRoute: AuthenticatedReportingRoute,
  AuthenticatedServicePartnersRoute: AuthenticatedServicePartnersRoute,
  AuthenticatedShowcaseRoute: AuthenticatedShowcaseRoute,
  AuthenticatedSitesRoute: AuthenticatedSitesRoute,
  AuthenticatedSteeringRoute: AuthenticatedSteeringRoute,
  AuthenticatedTasksRoute: AuthenticatedTasksRoute,
  AuthenticatedVehicleHandoversRoute: AuthenticatedVehicleHandoversRoute,
  AuthenticatedVehicleTypesRoute: AuthenticatedVehicleTypesRoute,
  AuthenticatedVehiclesRoute: AuthenticatedVehiclesRoute,
  AuthenticatedAffiliateManagementTeamsRoute:
    AuthenticatedAffiliateManagementTeamsRoute,
  AuthenticatedChargingContractsContractIdRoute:
    AuthenticatedChargingContractsContractIdRoute,
  AuthenticatedCompaniesCompanyIdRoute: AuthenticatedCompaniesCompanyIdRoute,
  AuthenticatedConfiguratorInvitesRoute: AuthenticatedConfiguratorInvitesRoute,
  AuthenticatedConfiguratorRequestsRoute:
    AuthenticatedConfiguratorRequestsRoute,
  AuthenticatedConfiguratorVehicleCategoriesRoute:
    AuthenticatedConfiguratorVehicleCategoriesRoute,
  AuthenticatedConfiguratorVehicleConversionsRoute:
    AuthenticatedConfiguratorVehicleConversionsRoute,
  AuthenticatedConfiguratorVehicleTypesRoute:
    AuthenticatedConfiguratorVehicleTypesRoute,
  AuthenticatedContractExpirationsContractExpirationIdRoute:
    AuthenticatedContractExpirationsContractExpirationIdRoute,
  AuthenticatedDossiersDossierIdRoute: AuthenticatedDossiersDossierIdRoute,
  AuthenticatedDossiersNewRoute: AuthenticatedDossiersNewRoute,
  AuthenticatedEmployeesEmployeeIdRoute: AuthenticatedEmployeesEmployeeIdRoute,
  AuthenticatedOrdersOrderIdRoute: AuthenticatedOrdersOrderIdRoute,
  AuthenticatedPlatformManagementAffiliatesRoute:
    AuthenticatedPlatformManagementAffiliatesRoute,
  AuthenticatedPlatformManagementCompaniesRoute:
    AuthenticatedPlatformManagementCompaniesRoute,
  AuthenticatedPlatformManagementServicePartnersRoute:
    AuthenticatedPlatformManagementServicePartnersRoute,
  AuthenticatedServicePartnersServicePartnerIdRoute:
    AuthenticatedServicePartnersServicePartnerIdRoute,
  AuthenticatedSteeringQueryIdRoute: AuthenticatedSteeringQueryIdRoute,
  AuthenticatedVehicleHandoversVehicleHandoverIdRoute:
    AuthenticatedVehicleHandoversVehicleHandoverIdRoute,
  AuthenticatedVehiclesVehicleIdRoute: AuthenticatedVehiclesVehicleIdRoute,
  AuthenticatedConfiguratorInvitesConfiguratorInviteIdRoute:
    AuthenticatedConfiguratorInvitesConfiguratorInviteIdRoute,
  AuthenticatedConfiguratorRequestsConfiguratorRequestIdRoute:
    AuthenticatedConfiguratorRequestsConfiguratorRequestIdRoute,
  AuthenticatedConfiguratorRequestsNewRoute:
    AuthenticatedConfiguratorRequestsNewRoute,
  AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRoute:
    AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdRoute,
  AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRoute:
    AuthenticatedConfiguratorVehicleTypesVehicleTypeIdRoute,
  AuthenticatedDossiersExportsExportIdRoute:
    AuthenticatedDossiersExportsExportIdRoute,
  AuthenticatedPlatformManagementAffiliatesAffiliateIdRoute:
    AuthenticatedPlatformManagementAffiliatesAffiliateIdRoute,
  AuthenticatedPlatformManagementAffiliatesNewRoute:
    AuthenticatedPlatformManagementAffiliatesNewRoute,
  AuthenticatedPlatformManagementCompaniesCompanyIdRoute:
    AuthenticatedPlatformManagementCompaniesCompanyIdRoute,
  AuthenticatedPlatformManagementCompaniesNewRoute:
    AuthenticatedPlatformManagementCompaniesNewRoute,
  AuthenticatedPlatformManagementServicePartnersServicePartnerIdRoute:
    AuthenticatedPlatformManagementServicePartnersServicePartnerIdRoute,
  AuthenticatedPlatformManagementServicePartnersNewRoute:
    AuthenticatedPlatformManagementServicePartnersNewRoute,
  AuthenticatedSteeringQueryIdNewRoute: AuthenticatedSteeringQueryIdNewRoute,
  AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRoute:
    AuthenticatedConfiguratorVehicleConversionsVehicleConversionIdEditRoute,
  AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRoute:
    AuthenticatedConfiguratorVehicleTypesVehicleTypeIdEditRoute,
  AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRoute:
    AuthenticatedSteeringQueryIdRevisionsRevisionIdEditRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
